<div id="mainsidenav" class="sidenavbar">
  <CDMS-Portal-U2-nav-item #panel [items]="parentScreens"></CDMS-Portal-U2-nav-item>
</div>
